/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the staging environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  LISTING_API_URL: 'https://listings.azurewebsites.net/api/',
  STORE_API_URL: 'https://cmostores.azurewebsites.net/api/',
  CMO_API_URL: 'https://api-staging.chatmyorder.com/',
  // CMO_API_URL: 'http://localhost:1408/',
  CMO_TICKET_API: 'https://support.chatmyorder.com/',
  CMO_CLOUD_API_URL: 'https://us-central1-chatmyorder.cloudfunctions.net/',
  CMO_RIDER_API: 'https://us-central1-cmo-riders-dev.cloudfunctions.net/',
  WEBSITE_URL: 'https://staging.chatmyorder.com/',
  MENU_IMPORT_SIMPLE_FILE_URL: 'https://chatmyorder.blob.core.windows.net/cmo/simple_item_import_format.xlsx',
  MENU_IMPORT_VARIABLE_FILE_URL: 'https://chatmyorder.blob.core.windows.net/cmo/variable_item_import_format.xlsx',
  stripe: {
    pk: 'pk_test_51HEVLpHovF15i47Co3QoPtQpSPcplrY4GhLx6vpmiEZF7CBI3dRIz3XkBBozTueVWQGaeGp7ANeRu4xTp88YxqXT00ZbAcuVpR',
  },
  pubnub: {
    pk: 'pub-c-7c49fa00-38a9-443c-b9e5-cf428fdf8c52',
    sk: 'sub-c-87931f46-b434-11ea-a40b-6ab2c237bf6e',
  },
  pubnub_real_time: {
    pk: 'pub-c-370f0295-3af2-4382-b9ff-4ecfa746a79b',
    sk: 'sub-c-03b98bac-91d7-11eb-a32c-e2ed87d6c533',
  },
  firebaseConfig: {
    apiKey: 'AIzaSyARivr3OdfgIqT4QK-Irg85X8hSa0cjjFE',
    authDomain: 'chatmyorder.firebaseapp.com',
    databaseURL: 'https://chatmyorder.firebaseio.com',
    projectId: 'chatmyorder',
    storageBucket: 'chatmyorder.appspot.com',
    messagingSenderId: '157118548742',
    appId: '1:157118548742:web:6c1b676a57b0530d9bac87',
    measurementId: 'G-P5WC0KDEZS',
  },
  BUGSNAG_API_KEY: '78e20cbb0c4d3491e17d8a4c7f4c01ea',
  BUGSNAG_APP_TYPE: 'business_portal',
  BUGSNAG_APP_VERSION: '2.3.0',
  BUGSNAG_APP_RELEASE_STAGE: 'staging',
  MAINTENANCE_MODE_DOC: 'maintenanceModeStagingBusiness',
  SUB_DOMAIN_SUFFIX: '.staging.chatmyorder.net',
  BROADCAST_CHANNEL: 'alert.cmo_broadcast_channel',
  RECAPTCHA_SITE_KEY: '6LdZbOIZAAAAAINT9fs-4JIXwWg-srNAP7ZCq5ZR',
  ENV: 'staging'
};
